<template>
  <div class="buy-credits__item">
    <div class="card__name">{{ shopPackage.name }}</div>

    <ElementTitle
      :shopPackage="shopPackage"
      :bonusAmount="bonusAmount"
      :amount="shopPackage.amount"
      :unit="shopPackage.unit"
      :type="shopPackage.type"
      :starter="!!shopPackage.is_starter"
    ></ElementTitle>

    <ElementPrice
      :price="price"
      :type="shopPackage.type"
      :starter="!!shopPackage.is_starter"
    ></ElementPrice>

    <ElementInfo :tags="shopPackage.tags"></ElementInfo>

    <ElementButton
      :buttonClass="{'button__outline button__outline--white-hov-purple': true}"
      :buttonLoading="buttonLoading"
      @buy="$emit('buy')"
    ></ElementButton>

    <slot></slot>
  </div>
</template>

<script>
import PackageMixin from './PackageMixin';
import ElementButton from './ElementButton';
import ElementTitle from './ElementTitle';
import ElementPrice from './ElementPrice';
import ElementInfo from './ElementInfo';

export default {
  name: 'SpecialEventPackage',
  mixins: [PackageMixin],
  components: { ElementPrice, ElementTitle, ElementButton, ElementInfo },
};
</script>
